export const GET_NEWS_LIST = 'get_news_list';
export const GET_ALL_LIST = 'get_all_list';
export const CLEAN_NEWS_LIST = 'clean_news_list';
export const GET_NEW = 'get_new';
